<template>
  <md-card>
    <md-card-header>
      <h2>Crear nuevo tipo de proveedor</h2>
    </md-card-header>
    <md-card-content>
      <div class="md-layout">
        <form novalidate class="md-layout-item" id="provider_type_form" @submit.prevent="submit">
          <div class="md-layout">
            <div class="md-layout-item md-size-50 md-xsmall-size-100">
              <div class="md-layout-item md-size-100 md-small-size-100">
                <md-field
                  :class="[
                    { 'md-valid': !errors.has('name') && touched.name },
                    { 'md-form-group': true },
                    { 'md-error': errors.has('name') },
                  ]"
                >
                  <md-icon>perm_contact_calendar</md-icon>
                  <label>Nombre</label>
                  <md-input
                    v-model="name"
                    data-vv-name="name"
                    type="text"
                    name="name"
                    required
                    v-validate="modelValidations.name"
                  ></md-input>
                  <slide-y-down-transition>
                    <md-icon class="error" v-show="errors.has('name')">close</md-icon>
                  </slide-y-down-transition>
                  <slide-y-down-transition>
                    <md-icon class="success" v-show="!errors.has('name') && touched.name">done</md-icon>
                  </slide-y-down-transition>
                </md-field>
              </div>
            </div>

            <div class="md-layout-item md-size-50 md-xsmall-size-100">
              <div class="md-layout-item md-size-100 md-small-size-100">
                <md-field
                  :class="[
                    { 'md-valid': !errors.has('code') && touched.code },
                    { 'md-form-group': true },
                    { 'md-error': errors.has('code') },
                  ]"
                >
                  <md-icon>label</md-icon>
                  <label>Código</label>
                  <md-input
                    v-model="code"
                    data-vv-name="code"
                    type="text"
                    name="code"
                    required
                    v-validate="modelValidations.code"
                  ></md-input>
                  <slide-y-down-transition>
                    <md-icon class="error" v-show="errors.has('code')">close</md-icon>
                  </slide-y-down-transition>
                  <slide-y-down-transition>
                    <md-icon class="success" v-show="!errors.has('code') && touched.code">done</md-icon>
                  </slide-y-down-transition>
                </md-field>
              </div>
            </div>
          </div>
        </form>
      </div>
    </md-card-content>
    <md-card-actions>
      <md-button type="submit" form="provider_type_form" class="md-success">Aceptar</md-button>
    </md-card-actions>
  </md-card>
</template>

<script>
import catalogService from "@/services/catalog";
import { SlideYDownTransition } from "vue2-transitions";

const modelValidations = {
  name: {
    required: true,
    min: 3,
  },
  code: {
    required: true,
    min: 2,
  },
};
const touched = {
  name: false,
  code: false,
};

export default {
  name: "RegisterProviderType",
  components: { SlideYDownTransition },
  data() {
    return {
      modelValidations,
      touched,
      name: "",
      code: "",
    };
  },
  methods: {
    submit() {
      this.isValid().then((res) => {
        if (res) {
          catalogService
            .create("provider_type", { name: this.name, code: this.code })
            .then(() =>
              this.$successMessage({
                title: "Tipo de proveedor registrado",
                text: "Se ha registrado un nuevo tipo de proveedor",
              })
            )
            .catch(this.$fireErrorResponse);
        }
      });
    },
    isValid() {
      return this.$validator.validateAll().then((res) => res);
    },
  },
  watch: {
    name() {
      this.touched.name = true;
    },
    code() {
      this.touched.code = true;
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/pages/Providers/wizard/RegisterProviderType.vue